import { render, staticRenderFns } from "./QgisPluginAdmin.vue?vue&type=template&id=76818be8&"
import script from "./QgisPluginAdmin.vue?vue&type=script&lang=js&"
export * from "./QgisPluginAdmin.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports